import React from 'react';
import { Modal, Form, Input } from 'antd';

const PasswordModal = ({ open, username, onCancel, onSubmit, loading }) => {
  const [form] = Form.useForm();

  const handleOk = async () => {
    const { password } = await form.validateFields();
    onSubmit(password);
    form.resetFields();
  };

  return (
    <Modal
      title={`Сменить пароль: ${username}`}
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      confirmLoading={loading}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="password"
          label="Новый пароль"
          rules={[{ required: true, min: 4, message: 'Минимум 4 символа' }]}
        >
          <Input.Password />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PasswordModal;
